export const marketplaceHeroData = {
  tagline: "CLOUD MARKETPLACE",
  title: "Automatiza ventas con tu marketplace cloud",
  subtitle: "Obtén un marketplace cloud white-label para automatizar suscripciones, optimizar operaciones y acelerar ventas con una plataforma de autoservicio 24/7.",
  cta: "Comenzar ahora",
  secondaryCta: "Ver demo"
};

export const marketplaceFeaturesData = [
  {
    id: 1,
    title: "Acceso 24/7 autoservicio",
    description: "Clientes y resellers pueden realizar pedidos, gestionar suscripciones, acceder a facturas y realizar pagos en cualquier momento.",
    icon: "Clock"
  },
  {
    id: 2,
    title: "Precios y provisioning automatizado",
    description: "Aplica precios conformes al vendor y activa suscripciones instantáneamente, incluyendo trials, sin intervención manual.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Seguimiento transparente de costes",
    description: "Monitorea consumo PAYG, costes y uso con dashboards en tiempo real, asegurando visibilidad total del gasto.",
    icon: "BarChart3"
  },
  {
    id: 4,
    title: "Facturación precisa",
    description: "Automatiza límites de compra, aplica términos de pago personalizados y genera facturas consolidadas.",
    icon: "FileText"
  }
];

export const marketplaceBenefitsData = [
  {
    id: 1,
    title: "Reduce trabajo manual",
    description: "Automatiza renovaciones, provisioning, facturación y onboarding de clientes para ahorrar tiempo y prevenir errores.",
    icon: "Settings"
  },
  {
    id: 2,
    title: "Fortalece precisión financiera",
    description: "Rastrea balances, aplica límites de compra, refuerza términos de pago y genera facturas claras y consolidadas.",
    icon: "Calculator"
  },
  {
    id: 3,
    title: "Mejora visibilidad y control",
    description: "Accede a datos financieros en tiempo real, monitorea transacciones y obtén insights para optimizar gestión de ingresos.",
    icon: "Eye"
  },
  {
    id: 4,
    title: "Impulsa oportunidades de ingresos",
    description: "Ofrece soluciones en bundle, precios dinámicos y cross-selling automatizado para maximizar el valor del cliente.",
    icon: "TrendingUp"
  },
  {
    id: 5,
    title: "Expande tu base de clientes",
    description: "Vende online sin esfuerzo, atrae más clientes y proporciona experiencia de autoservicio para transacciones más rápidas.",
    icon: "Users"
  },
  {
    id: 6,
    title: "Acelera go-to-market",
    description: "Un marketplace personalizable te ayuda a introducir nuevos servicios, optimizar precios y escalar globalmente.",
    icon: "Rocket"
  }
];

export const vendorIntegrationsData = [
  {
    id: 1,
    name: "Microsoft",
    description: "Automatiza licenciamiento, provisioning y renovaciones para Microsoft 365, Azure y más.",
    category: "Productividad & Cloud",
    logo: "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
    features: ["Microsoft 365", "Azure", "Dynamics 365", "Power Platform"]
  },
  {
    id: 2,
    name: "Adobe",
    description: "Simplifica activación de licencias y optimiza renovaciones con Adobe VIP Marketplace.",
    category: "Creatividad & Diseño",
    logo: "https://upload.wikimedia.org/wikipedia/commons/8/8d/Adobe_Corporate_Logo.png",
    features: ["Creative Cloud", "Acrobat", "Adobe Sign", "Experience Cloud"]
  },
  {
    id: 3,
    name: "AWS",
    description: "Gestiona servicios cloud de Amazon Web Services con automatización completa.",
    category: "Infraestructura Cloud",
    logo: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg",
    features: ["EC2", "S3", "Lambda", "RDS"]
  },
  {
    id: 4,
    name: "Google Cloud",
    description: "Integra servicios de Google Cloud Platform con provisioning automatizado.",
    category: "Infraestructura Cloud",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/51/Google_Cloud_logo.svg",
    features: ["Compute Engine", "Cloud Storage", "BigQuery", "Kubernetes"]
  },
  {
    id: 5,
    name: "Acronis",
    description: "Gestiona suscripciones de ciberseguridad y backup con automatización completa.",
    category: "Seguridad & Backup",
    logo: "https://upload.wikimedia.org/wikipedia/commons/7/7f/Acronis_logo.png",
    features: ["Cyber Protect", "Backup Cloud", "Disaster Recovery", "File Sync"]
  },
  {
    id: 6,
    name: "Dropbox",
    description: "Vende almacenamiento cloud con facturación y provisioning automatizado.",
    category: "Almacenamiento & Colaboración",
    logo: "https://upload.wikimedia.org/wikipedia/commons/7/78/Dropbox_Icon.svg",
    features: ["Business Standard", "Business Advanced", "Enterprise", "DocSend"]
  },
  {
    id: 7,
    name: "Kaspersky",
    description: "Entrega soluciones de ciberseguridad con actualizaciones en tiempo real.",
    category: "Seguridad",
    logo: "https://upload.wikimedia.org/wikipedia/commons/1/12/Kaspersky_logo.svg",
    features: ["Endpoint Security", "Small Office Security", "Internet Security", "Total Security"]
  },
  {
    id: 8,
    name: "Sophos",
    description: "Automatiza ventas de suscripciones para servicios de seguridad avanzada.",
    category: "Seguridad",
    logo: "https://upload.wikimedia.org/wikipedia/commons/2/25/Sophos_logo.svg",
    features: ["Intercept X", "Firewall", "Email Security", "Cloud Optix"]
  },
  {
    id: 9,
    name: "ESET",
    description: "Habilita ventas automatizadas de suscripciones de seguridad ESET y renovaciones.",
    category: "Seguridad",
    logo: "https://upload.wikimedia.org/wikipedia/commons/3/30/ESET_logo.svg",
    features: ["Endpoint Protection", "Secure Business", "Cloud Administrator", "File Security"]
  },
  {
    id: 10,
    name: "BitTitan",
    description: "Gestiona servicios de migración cloud con soporte de vendor integrado.",
    category: "Migración",
    logo: "https://www.bittitan.com/wp-content/uploads/2021/06/BitTitan-Logo.svg",
    features: ["MigrationWiz", "Voleer", "Deployment Pro", "User Activation"]
  },
  {
    id: 11,
    name: "SkyKick",
    description: "Simplifica backup cloud y gestión de seguridad.",
    category: "Backup & Migración",
    logo: "https://www.skykick.com/wp-content/uploads/skykick-logo.svg",
    features: ["Cloud Backup", "Migration Suite", "Security Manager", "Office 365 Backup"]
  },
  {
    id: 12,
    name: "Dropsuite",
    description: "Ofrece backup cloud y seguridad de email sin problemas.",
    category: "Backup & Email",
    logo: "https://www.dropsuite.com/wp-content/uploads/dropsuite-logo.svg",
    features: ["Email Backup", "Email Archiving", "Website Backup", "Database Backup"]
  }
];

export const vendorCategoriesData = [
  { id: 1, name: "Productividad & Cloud", count: 1, color: "#1297fd" },
  { id: 2, name: "Creatividad & Diseño", count: 1, color: "#40aaf8" },
  { id: 3, name: "Infraestructura Cloud", count: 2, color: "#8bcaf9" },
  { id: 4, name: "Seguridad & Backup", count: 1, color: "#1297fd" },
  { id: 5, name: "Seguridad", count: 3, color: "#40aaf8" },
  { id: 6, name: "Almacenamiento & Colaboración", count: 1, color: "#8bcaf9" },
  { id: 7, name: "Migración", count: 1, color: "#1297fd" },
  { id: 8, name: "Backup & Migración", count: 1, color: "#40aaf8" },
  { id: 9, name: "Backup & Email", count: 1, color: "#8bcaf9" }
];

export const marketplaceStatsData = [
  { number: "120+", label: "Aplicaciones SaaS" },
  { number: "24/7", label: "Disponibilidad" },
  { number: "99.98%", label: "Precisión en facturación" },
  { number: "1-Click", label: "Despliegue" }
];

export const marketplaceFAQData = [
  {
    question: "¿Qué es un cloud marketplace?",
    answer: "Un cloud marketplace es un escaparate de autoservicio donde clientes o resellers compran, gestionan y pagan suscripciones, respaldado por automatización para precios, provisioning, facturación y pagos."
  },
  {
    question: "¿Cómo funciona un cloud marketplace?",
    answer: "Los clientes navegan un catálogo curado, seleccionan planes y completan la compra en segundos; la plataforma aplica precios conformes al vendor, provisiona servicios instantáneamente y genera facturas consolidadas claras."
  },
  {
    question: "¿Qué es un marketplace white-label?",
    answer: "Un marketplace white-label es tu marketplace con tu marca, políticas de precios y experiencia de cliente, ejecutándose sobre un motor de automatización que mantiene catálogos, provisioning, costes y facturas alineados."
  },
  {
    question: "¿Por qué son importantes las integraciones de vendors?",
    answer: "Las conexiones con vendors mantienen catálogos, provisioning, uso y facturación sincronizados para que lo que vendes sea exactamente lo que se activa y factura. Reducen procesos manuales y errores."
  }
];
